import { i18n } from 'app/utils/i18n';

export default function DraftMark() {
  return <div className="info-blob">{i18n('infoblob.isDraft')}</div>;
}
